var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showEnvLogo)?_c('div',{staticClass:"env-logo"},[_c('span',{class:_vm.envNameClz},[_vm._v(_vm._s(_vm.envNameDisp))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }